module.exports = __webpack_public_path__ + "static/media/menu-icon.2fb9a0c3.svg";